import { CaptionLineConfig, CaptionStyle } from '../types/asset-types';
import { BrandKitStore, PlatformBrandKitStore } from '../types/brand-kit-types';
import { Clip } from '../types/clip-types';
import { FontItem } from '../types/font-types';
import {
  CaptionTrackMetadata,
  CaptionSegmentData
} from '../types/RemotionPlayerConfigTypes/Track/CaptionsTrack/CaptionsTrack';
import { SegmentsTrack } from '../types/RemotionPlayerConfigTypes/Track/SegmentsTrack';
import { SegmentType } from '../types/Segment/Type';
import { getAllSegments, isSplitsInTimelineEnabledPure } from './clipUtils';
import { getFontFamilyStylePure } from './fontUtils';
import { getCaptionsForSegment } from './playerConfigUtils';

export function getCaptionStyles(
  animation: CaptionStyle | undefined,
  scale: number | undefined,
  fontItem?: FontItem,
  outlineColor: string = '#000'
) {
  let strokeWidth = (scale || 1) / 2;
  if (fontItem?.size === 'xs') {
    strokeWidth /= 2;
  }
  switch (animation) {
    case CaptionStyle.Outline:
      return {
        textShadow: `-${strokeWidth}px -${strokeWidth}px 0.7px ${outlineColor}, ${strokeWidth}px -${strokeWidth}px 0.7px ${outlineColor}, -${strokeWidth}px ${strokeWidth}px 0.7px ${outlineColor}, ${strokeWidth}px ${strokeWidth}px 0.7px ${outlineColor}, -${strokeWidth}px -${strokeWidth}px 0.7px ${outlineColor}, ${strokeWidth}px -${strokeWidth}px 0.7px ${outlineColor}, -${strokeWidth}px ${strokeWidth}px 0.7px ${outlineColor}, ${strokeWidth}px ${strokeWidth}px 0.7px ${outlineColor}`
      } as Record<string, any>;
    default:
      return {};
  }
}
export function buildCaptionMetadata({
  clip,
  mainTrack,
  isSplitsTranslationEnabled,
  clipBrandKitStore,
  brandKitStore,
  platformBrandKit,
  organization
}: {
  clip: Clip;
  mainTrack?: SegmentsTrack;
  isSplitsTranslationEnabled: boolean;
  clipBrandKitStore: BrandKitStore;
  brandKitStore: BrandKitStore;
  platformBrandKit: PlatformBrandKitStore;
  organization?: string | null | undefined;
}): CaptionTrackMetadata {
  const allSegments = mainTrack ? mainTrack.segments : getAllSegments(clip);
  const segmentWiseData: CaptionSegmentData[] = [];
  let frameOffset = 0;

  const isSplitsEnabled = isSplitsInTimelineEnabledPure({ clip, isSplitsTranslationEnabled });

  for (const segment of allSegments) {
    if (segment.type === SegmentType.COMPOSITE) {
      const captions = getCaptionsForSegment({ clip, segmentId: segment.id, isSplitsTranslationEnabled }) || [];
      segmentWiseData.push({
        segmentId: segment.id,
        segmentType: SegmentType.COMPOSITE,
        captions,
        offset: isSplitsEnabled ? frameOffset : 0
      });
    }
    frameOffset += segment.toFrame - segment.fromFrame;
  }

  const fontFamily = getFontFamilyStylePure({
    clip,
    fontLocation: clip.asset_metadata.caption_styles?.font_location || clip.asset_metadata.font_location,
    clipBrandKitStore,
    brandKitStore,
    platformBrandKit,
    organization
  });

  return {
    segmentWiseData,
    fontFamily,
    captionStyles: clip.asset_metadata.caption_styles,
    lineConfig: clip.asset_metadata.caption_styles?.line_config || CaptionLineConfig.OneLine,
    captionPosition: clip.asset_metadata.caption_positions,
    size: clip.asset_metadata.size,
    layout: clip.asset_metadata.layout,
    clipStart: clip.asset_metadata.start,
    clipEnd: clip.asset_metadata.end
  };
}
